import { GraphComponent, GraphItemTypes, Point } from '@ardoq/yfiles';
import { isCollapsibleGroup, isNode } from '@ardoq/graph';
import { ClientModelHitTest } from 'tabview/canvasRendering/canvasHitTestRegistry';

/**
 * yFiles nodes carry the component id as a DOM attribute, but the input layer
 * above them means a pointer event's target is rarely the node itself. Asking
 * yFiles by coordinate is the reliable question, and it is the same one the
 * canvas-rendered views answer.
 *
 * Groups are nodes to yFiles too, and the ones a parent grouping draws stand
 * for a component, so they answer with it.
 */
export const toClientModelHitTest =
  (graphComponent: GraphComponent): ClientModelHitTest =>
  ({ clientX, clientY }) => {
    const {
      graphModelManager,
      renderTree: { contentGroup },
    } = graphComponent;
    const [hitElement] = graphModelManager.hitElementsAt({
      location: graphComponent.pageToWorldCoordinates(
        new Point(clientX, clientY)
      ),
      root: contentGroup,
      typeFilter: GraphItemTypes.NODE,
    });
    const graphItem = hitElement?.tag;
    if (isNode(graphItem)) return graphItem.modelId;
    if (isCollapsibleGroup(graphItem) && graphItem.isComponent()) {
      return graphItem.modelId;
    }
    return null;
  };
